module.exports = __webpack_public_path__ + "assets/img/2b5153f5c482d606ed92b0fbeccb3398.png";